import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import illustration from "../../../assets/images/appImages/illustration.png";
import { TeamData } from "./data";


export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
  twitter,
  facebook,
  linkedin,
}: {
  photo?: string;
  name: string;
  role: string;
  twitter?: string;
  facebook?: string;
  linkedin?: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};



function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5 pb-5">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="illustration-container">
                  <img loading="lazy" src={illustration} alt="image" />
                </div>

              </div>
              <div className="col-md-6 mb-4">
                <CustomBeautyTitle title="Qui sommes nous?" />
                <h3 className="custom-title">Khadim Rassoul Abonnement</h3>
                <div className="custom-content">
                  Khadim Rassoul Abonnement est un service que nous avons créé pour vous accompagner et vous permettre de gérer
                  vos abonnements à diverses plateformes en toute simplicité. <br />
                  Depuis avril 2024, plus de 500 personnes nous ont fait confiance pour tous leurs besoins en abonnement.
                  Nous collaborons également avec plusieurs showrooms et propriétaires d’immeubles pour des installations TV, notamment l’IPTV
                </div>
              </div>
              <div className="col-lg-12 mb-4">
                <div className="custom-content">
                  Notre équipe se mobilise 24h/24 et 7j/7 pour vous offrir un service de qualité.
                  Avec nous, votre satisfaction est garantie : en cas de non-satisfaction, nous vous remboursons.
                  Chez nous, le client est roi. Dites-nous ce que vous souhaitez, et nous nous occupons de tout !
                </div>
              </div>
            </div>
          </div>

          <div className="my-5 our-team gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Notre équipe</h3>
              <div className="row pt-4">
                {!!TeamData &&
                  TeamData.map((member, key) => {
                    return (
                      <div className="col-lg-3 col-md-4 mb-4 card-wrapper" key={key}>
                        <TeamCard
                          photo={member.photo}
                          name={member.name}
                          role={member.role}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

        </div>

      </div>
      <div style={{ padding: '5rem 0' }}></div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
